import { render, staticRenderFns } from "./CustomThemedButton.vue?vue&type=template&id=148640da&scoped=true&"
import script from "./CustomThemedButton.vue?vue&type=script&lang=js&"
export * from "./CustomThemedButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomThemedButton.vue?vue&type=style&index=0&id=148640da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148640da",
  null
  
)

export default component.exports